import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

/*
  Generated class for the UserServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserServiceProvider {

  constructor(
    public http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider
  ) {

  }

  getUser(tuid: any) {
    return new Promise((resolve, reject) => {

      if (!tuid){
        return reject();
      }

      this.http.get('/user/' + tuid).subscribe(res => {
        return resolve(res);
      }, error => {
        return reject(this.apiErrorHandler.handleError(error));
      });

    });
  }

  setUserLastBookingTeamId(){
    return new Promise((resolve,reject)=>{

      this.getUser(localStorage.getItem('tuid')).then((user:any) =>{
        localStorage.setItem('lastBookingTeamId', user.last_booking_team_id);
        return resolve(user.last_booking_team_id);
      }).catch(()=>{
        // Fail silently is user id not set;
        // console.log('USER NOT LOGGED IN OR PASSED TO METHOD');
        return resolve(null);
      });

    });

  }

}



// WEBPACK FOOTER //
// ./src/providers/user-service/user-service.ts